<template>
  <CCard style="margin-top: 20px">
    <CCardBody>
      <!-- <CButton
        color="primary"
        class="mb-2"
        :href="csvCode"
        download="coreui-table-data.csv"
        target="_blank"
      >
        Download current items (.csv)
      </CButton> -->
      <JsonCSV
      color="primary"
    class   = "btn btn-default mb-2 clr"
    :data   = "tableData2"
    name    = "rage_capture-list.csv">
    
    Download CSV (This is a slot)
 
</JsonCSV>
      <CSelect
        horizontal
        :options="options"
        placeholder="Please select"
        v-model="fielterdata"
        @change="onChange($event)"
        style="width: 300px; float: right; margin-left: 50px; margin-top: 6px"
      />
      <CDataTable
        :items="tableData2"
        :fields="fields"
        column-filter
        :items-per-page="10"
        hover
        sorter
        pagination
        @filtered-items-change="setCurrentItems"
      >
        <template #phoneNumber="{ item }">
          <td>
            <span v-if="item.phoneNumber">
              {{item.phoneNumber}}
            </span>
          </td>
        </template>
        <template #Action="{ item, index }">
          <td style="text-align: center !important">
            <CButton
              color="primary"
              variant="outline"
              square
              size="sm"
              style="width: 84px"
              @click="editToken(item, index)"
            >
              Set limit
            </CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <CModal title="Add Token limit" :show.sync="myModal">
      <CInput placeholder="Enter coin" type="number" v-model="stakeLimit" />
      <span v-if="filetext" style="color: red">please enter coin</span>
      <template #footer>
        <!-- <CButton @click="darkModal = false" color="danger">cancel</CButton> -->
        <CButton color="success" @click="updatetokenlimit()">add</CButton>
      </template>
    </CModal>
  </CCard>
</template>

<script>
import usersData from "../users/UsersData";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import JsonCSV from 'vue-json-csv'
const db = firebase.firestore();

export default {
  name: "DownloadTable",
  components:{
    JsonCSV
  },
  data() {
    return {
      filetext: false,
      itemEmail: "",
      myModal: false,
      usersData,
      currentItems: [],
      grapdata: "",
      stakeLimit: 0,
      fielterdata: "",
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      options: [],
      fields: [
        {
          label: "ID",
          key: "id",
          sortable: true,
        },
        {
          label: "Token count",
          key: "TRAGE",
          sortable: true,
        },
        {
          label: "Ethereum",
          key: "Ethereum",
          sortable: true,
        },
         {
          label: "Country",
          key: "Country",
          sortable: true,
        },
         {
          label: "Mobile no",
          key: "phoneNumber",
          sortable: true,
        },
        // {
        //   key: "Action",
        //   _style: "text-align:center !important",
        //   sortable: true,
        // },
      ],
      details: [],
      collapseDuration: 0,
      conditionLimit: 0,
    };
  },
  computed: {
    csvContent() {
      return this.currentItems
        .map((item) => Object.values(item).join(","))
        .join("\n");
    },
    csvCode() {
      return (
        "data:text/csv;charset=utf-8,SEP=,%0A" +
        encodeURIComponent(this.csvContent)
      );
    },
  },
  methods: {
    updatetokenlimit() {
      // console.log("docs[0]", this.itemEmail)
      // console.log("docs[1]",item.TRAGE)
      //  console.log("docs[2]",this.stakeLimit)
      if (this.stakeLimit.length > 0) {
        db.collection("users")
          .where("email", "==", this.itemEmail)
          .get()
          .then((snapShot) => {
            snapShot.forEach((doc) => {
              if (!doc.length > 0) {
                // console.log("docs[0]",doc.data())
                let stakeLimit = doc.data().stakeLimit;
                if (stakeLimit) {
                  let lable = this.grapdata;
                  let value = this.stakeLimit;
                  let data = stakeLimit;
                  data[lable] = parseInt(value);
                  // console.log("data[lable]",data[lable])
                  db.collection("users")
                    .doc(doc.id)
                    .update({ stakeLimit: data });
                  Swal.fire(
                    "success",
                    this.itemEmail + " User limit updated successfully",
                    "success"
                  );
                  this.myModal = false;
                } else {
                  let lable = this.grapdata;
                  let value = this.stakeLimit;
                  let data = {
                    stakeLimit: {},
                  };
                  data["stakeLimit"][lable] = parseInt(value);
                  db.collection("users").doc(doc.id).update(data);
                }
              }
            });
          });
      } else {
        // console.log("enter input")
        this.filetext = true;
      }
    },
    editToken(item, index) {
      this.itemEmail = item.id;
      if (this.conditionLimit <= item.TRAGE) {
        this.myModal = true;

        // Swal.fire("success", "Your have to access)", "success");
      } else {
        Swal.fire("Cancelled", "Coin collection limt is low", "error");
      }
      console.log("edit token item", item.id);
      // console.log("Edit token index",index);
      // this.$router.push({ name: "editUser", params: { id: item.id } });
    },
    setCurrentItems(val) {
      this.currentItems = val;
    },
    toggleDetails(item) {
      this.$set(this.tableData[item.id], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
    wizard() {
      this.$router.push({ name: "wizard" });
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        symbol: doc.data().symbol,
        totalSupply: doc.data().totalSupply,
        companyName: doc.data().companyName,
        description: doc.data().description,
        country: doc.data().country,
        ethereum: doc.data().ethAddress,
        contract: doc.data().conAddress,
        location: doc.data().location,
        logo: doc.data().logo,
        coinLimit: doc.data().coinLimit,
      };
      return smallDocument;
    },
    assignscaptureData(doc) {
      let emaildata = this.tableData4.filter((a) => {
        return a.email == doc.id;
      });
      // console.log("emaildata",emaildata[0].ethAddress)
      let smallDocument = {
        id: doc.id,
        TRAGE: doc.data()[this.grapdata].length,
        Ethereum: emaildata[0].ethAddress,
        Country: emaildata[0] != undefined ? emaildata[0].country : 0,
        phoneNumber: emaildata[0] != undefined ? emaildata[0].phoneNumber : 0,
      };
      return smallDocument;
    },
    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("companyDetails2")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));

            let value = this.tableData.map((n) => {
              return n.name;
            });

            this.options = value;
          });
          this.loading = false;
        });
    },
    onChange(event) {
      // onChange() {
      this.tableData2 = [];
      this.grapdata = event.target.value;
      // this.grapdata = "TRAGE Token";
      console.log("grapdata", this.grapdata);

      const db = firebase.firestore();
      db
        .collection("companyDetails2")
        .where("name", "==", this.grapdata)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("this.tableData2", this.assignsmallData(doc).coinLimit);
            this.conditionLimit = this.assignsmallData(doc).coinLimit;
            console.log("this.conditionLimit", this.conditionLimit);
          });
        }),
      db.collection("users")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData4.push(doc.data());
          });
       
          db.collection("collectedCoins2")
            .where(this.grapdata, "!=", null)
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data()[this.grapdata].length == 0) {
                  this.tableData3.push(this.assignscaptureData(doc));
                  this.tableData2 = [];
                } else {
                  this.tableData2.push(this.assignscaptureData(doc));
                }
              });
              this.currentItems = this.tableData2.slice();
              this.loading = false;
            });
        });
    },
    rowClicked(item, index, column, e) {
      // console.log("edit item", item.id);
      this.documentId = item.id;
    },

    deleteRoute(item) {
      // console.log("deleteRoute", item.id);
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("companyDetails")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.gettokens();
    // this.onChange();
    // this.captureToken();
  },
};
</script>
<style >
.clr{
  color: #fff !important;
    background-color: #321fdb !important;
}
</style>